"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Facebook, Twitter, Linkedin, Instagram, Github, Send } from "lucide-react";
const NewsletterForm = () => {
  const {
    isSubmitting,
    handleSubmit,
    control
  } = useWvcForm();
  return <Form onSubmit={handleSubmit} className="w-full space-y-2">
      <div data-section-id="29329" className="flex w-full gap-2">
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1">
              <FormControl>
                <input {...field} placeholder="Enter your email" className="flex h-10 w-full rounded-none border border-[#0D9488]/30 bg-[#FFF7ED] px-3 py-2 text-sm text-[#333333] ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#333333]/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6B35] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" aria-label="Email address" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <Button type="submit" size="icon" disabled={isSubmitting} className="shrink-0 bg-[#FF6B35] hover:bg-[#D8A7CA] text-white rounded-none transition-colors duration-300">
          <Send className="size-4" />
          <span className="sr-only">Subscribe</span>
        </Button>
      </div>
      <p className="text-[10px] text-[#333333]/70">
        By subscribing, you agree to our Privacy Policy and consent to receive updates.
      </p>
    </Form>;
};
export default function CompanyDirectory() {
  const currentYear = new Date().getFullYear();
  const products = ["Popular Boy Names", "Popular Girl Names", "Trending Names", "Unique Meanings", "Biblical Origins", "A-Z Directory"];
  const resources = [{
    label: "Boy Names",
    href: "/BoyNamesPage"
  }, {
    label: "Girl Names",
    href: "/GirlNamesPage"
  }, {
    label: "Unique Names",
    href: "/UniqueNamesPage"
  }, {
    label: "Trending Names",
    href: "/TrendingPage"
  }, {
    label: "Biblical Names",
    href: "/BiblicalPage"
  }];
  const company = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "About Us",
    href: "#"
  }, {
    label: "Contact Us",
    href: "#"
  }, {
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }];
  const socialLinks = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Github,
    href: "#",
    label: "GitHub"
  }];
  return <section id="footer" className="bg-[#A7F3D0] text-[#333333] border-t border-[#0D9488]/20 font-sans">
      <div className="max-w-7xl mx-auto px-4 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          {}
          <div className="lg:col-span-1 flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="/img/connects_pro_logo.png" alt="NamesOfTheWorld.com Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-[#333333]/80 leading-relaxed">
              NamesOfTheWorld.com offers beautifully organized lists of baby names to help parents find the perfect inspiration for their new arrival.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => <Link key={i} to={social.href} className="text-[#333333]/60 hover:text-[#D8A7CA] transition-colors duration-200" aria-label={social.label} data-index={i}>
                  <social.icon className="size-5" />
                </Link>)}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-[#0D9488] tracking-tight">Categories</h3>
            <ul className="flex flex-col gap-3">
              {products.map((item, i) => <li key={i} data-index={i}>
                  <Link to="/HomePage" className="text-sm text-[#333333] hover:text-[#D8A7CA] transition-colors duration-200">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-[#0D9488] tracking-tight">Name Lists</h3>
            <ul className="flex flex-col gap-3">
              {resources.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-[#333333] hover:text-[#D8A7CA] transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-[#0D9488] tracking-tight">Information</h3>
            <ul className="flex flex-col gap-3">
              {company.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-[#333333] hover:text-[#D8A7CA] transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-1 flex flex-col gap-6">
            <h3 className="font-bold text-[#0D9488] tracking-tight">Stay Updated</h3>
            <p className="text-sm text-[#333333]/80">
              Subscribe to our newsletter for the latest naming trends and baby inspiration delivered to your inbox.
            </p>
            <FormProvider formId="footer-newsletter" sectionName="footer" defaultValues={{
            email: ""
          }} className="w-full">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>

        <Separator className="my-12 bg-[#0D9488]" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#333333]/60">
          <p>&copy; {currentYear} NamesOfTheWorld.com. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-[#D8A7CA] transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-[#D8A7CA] transition-colors duration-200">
              Terms of Service
            </Link>
            <Link to="#" className="hover:text-[#D8A7CA] transition-colors duration-200">
              Cookie Settings
            </Link>
          </div>
        </div>
      </div>
    </section>;
}